import { useEffect, useState } from 'react';
import {useSelector} from "react-redux";
import {getMaintenance} from "../../reducers/configSlice";
import {emitFutureBookingList} from "../socket/socket";
import {STORAGE} from "../storage";

const useIntervalCurrentBooking = () => {
    const maintenance = useSelector(getMaintenance);

    // State to track if Soketi is being used
    const [isSoketiActive, setIsSoketiActive] = useState(false);

    // Check if Soketi is active on mount
    useEffect(() => {
        const checkSoketiStatus = async () => {
            const soketiUrl = await STORAGE.get("soketiUrl");
            setIsSoketiActive(!!soketiUrl);
        };
        checkSoketiStatus();
    }, []);

    useEffect(() => {
        // Skip this interval if Soketi is active - Soketi handles booking list updates via events and API
        if (isSoketiActive) {
            // console.log('[INTERVAL_CURRENT_BOOKING] Soketi is active, skipping Socket.IO booking list interval');
            return;
        }

        const intervalCurrentBooking = setInterval(() => {
            if (!maintenance) {
                emitFutureBookingList();
            }
        }, 1000 * 6); // Emit every 1 minute

        return () => clearInterval(intervalCurrentBooking);
    }, [maintenance, emitFutureBookingList, isSoketiActive]);
};

export default useIntervalCurrentBooking;